// AJAX ///////////////////
// GLOBAL VARIABLES
// Url without site root
urlActualPage = ""
actualRequest = ""
var scrollHeader;
var inTransition = false;

// UPDATE NAV
function updateNav(link){

	if(link){
		// CLICKED ON NAV
		urlActualPage = link;
	}
	else{
        // INIT LOAD
        // no action for
	}

}

// UPDATE NAV
function updateNav(link){

    // RECOVER urlActualPage
	if(link){
		// CLICKED ON NAV
		urlActualPage = link;
        // ACTIVATE ITEM IN PRIMARY NAV IF NECESSARY
        jQuery('.primaryNav .active').removeClass('active');
        jQuery('.primaryNav a[href="' + urlActualPage + '"]').parent().addClass('active');
        // STRIP BEGINNING OF URL
		urlActualPage = urlActualPage.replace(app.baseUrl,'');
	} else {
        // INITIAL STAGE
        urlActualPage = app.currentURL;
        // ACTIVATE ITEM IN PRIMARY NAV IF NECESSARY
        jQuery('.primaryNav .active').removeClass('active');
        if( urlActualPage != app.baseUrl+"/" ){
            jQuery('.primaryNav a[href="' + urlActualPage + '"]').parent().addClass('active');
        }
    }

    //console.log("urlActualPage"+urlActualPage);

}

// UPDATE HISTORY
function updateHistory(link){
	if(app.isHistoryAvailable) {
		// particular case: default home
		if( urlActualPage == "" ) {
			urlActualPage = "/";
		}
		// update history
		history.pushState(
            {
                ajx : true,
                link : link
            }, "", urlActualPage);
	} else {
		// Update browser address
		setURL(urlActualPage);
    }

    // GOOGLE ANALYTICS
    serverName = jQuery("body").attr("data-siteurl");
	if( serverName != "dev.pilot500.com" && serverName!="preprod.pilot500.com" && serverName!="dev.pilot500.fmixlab.com") {
        gtag('config', 'UA-162022435-1',{
            'page_path': urlActualPage
          });
    }
}

// GET PAGE
function ajax_goToActualPage(langChange){
    // FADE OUT ACTUAL CONTENT
    // Mantain height for no closing gap
    contentHeight = jQuery("#content").height();
    jQuery("#content").css("height",contentHeight);
    // Fade out
    jQuery(".parallax-mirror").fadeOut(function(){
        $(this).remove();
    });
    jQuery("#content .mainContent").fadeOut(function(){
        // COMPLETE
        // Scroll top
        $("html, body").animate({ scrollTop: 0 }, "slow",function(){
            // Update parallax elements
            jQuery("[data-parallax]").each(function(index){
                $imgURL = $(this).attr("data-image-src");
                $(this).parallax({$imgURL});
                });
        });
        return false;
    });

    // REQUEST NEW PAGE
    if(actualRequest) actualRequest.abort();
    closeMenu();
    // REQUEST NEW PAGE
 	actualRequest = $.ajax({
 		url: urlActualPage,
 		cache: false,
 		dataType: 'html',
 		success: function(data) {
            // ENABLE HEADER SCROLL
            refreshMenuHome();
            activateHeaderScroll();

 			// RECOVER WP body CLASSES
			var matches = data.match(/<body.*class=["']([^"']*)["'].*>/),
    		classes = matches && matches[1];
            jQuery("body").removeClass().addClass(classes);

            // CHANGE HEAD
            jQuery('head').html(jQuery(data).find('head').html());
            document.title = jQuery(data).filter('title').text();

 			// CHANGE HTML MAINCONTENT
            jQuery('#content .mainContent').html(jQuery(data).find('#content .mainContent').html());

            // CHANGE HTML SECONDARYNAV
            jQuery('header .langChoiceBloc').html(jQuery(data).find('header .langChoiceBloc').html());

            // IF CHANGE OF LANG RENEW MENU
            if(langChange){
                jQuery('header .primaryNavContainer').html(jQuery(data).find('header .primaryNavContainer').html());
                jQuery('header .logoHeader').html(jQuery(data).find('header .logoHeader').html());
                jQuery('footer>.row').html(jQuery(data).find('footer>.row').html());
                activatePrimaryNav();
                activateFooterNav();
            }

 			jQuery(document).ready( function(){

                inTransition = false;

                // HEIGHT AUTO
                jQuery("#content").css("height","auto");

				setTimeout(function(){
                    // INIT PAGES

                    // Force refresh parallax
                    jQuery(window).trigger('resize');

                    // INIT LANG NAV
                    // INIT LANG NAV | TEMPORARY disabled
	                // initLangNav();

                    // Activate ajax buttons in content
                    activateContent();
                    activateLangNav();

                    }, 200);

                    // Update parallax elements
                    jQuery("[data-parallax]").each(function(index){
                       $imgURL = $(this).attr("data-image-src");
                       $(this).parallax({$imgURL});
                    });

                    // INIT ANCHOR LIST NAV
                    initAnchorListNav();

                    // Init carrousels
                    initCarousels();

                    // FADE IN
                    jQuery("#content .mainContent").fadeIn();

			},0.2);

 		}

 	});

	return false;
}

// NAV | CLICK BINDING
function activatePrimaryNav(){
    //console.log("CLICKBINDING ON PRIMARYNAV AND LOGO");
	jQuery(".ajxNav").click(function(event){

        inTransition = true;

        // PREVENT DEFAULT
        event.preventDefault();

        //  MOBILE
		closeSideNav();

		// UPDATE NAV
		var link = jQuery(this);
        linkURL = jQuery(link).attr("href");
        updateNav(linkURL);

		// LOAD PAGE
		ajax_goToActualPage();

		// UPDATE HISTORY
        updateHistory(linkURL);

	});
}

function activateFooterNav(){
    //console.log("CLICKBINDING ON PRIMARYNAV AND LOGO");
	jQuery("footer .ajxNav").click(function(event){

        // PREVENT DEFAULT
        event.preventDefault();

		// UPDATE NAV
		var link = jQuery(this);
        linkURL = jQuery(link).attr("href");
        updateNav(linkURL);

		// LOAD PAGE
		ajax_goToActualPage();

		// UPDATE HISTORY
        updateHistory(linkURL);

	});
}

function activateContent(){
    //console.log("CLICKBINDING ON CONTENT");
	jQuery("#content .ajxNav").click(function(event){

       // PREVENT DEFAULT
       event.preventDefault();

       //  MOBILE
       closeSideNav();

		// UPDATE NAV
		var link = jQuery(this);
        linkURL = jQuery(link).attr("href");
        updateNav(linkURL);

		// LOAD PAGE
		ajax_goToActualPage();

		// UPDATE HISTORY
		updateHistory(linkURL);

	});
}

function activateLangNav(){
    //console.log("CLICKBINDING ON LANGNAV");
	jQuery("#langChoiceWidget .ajxNav").click(function(event){

       // PREVENT DEFAULT
       event.preventDefault();

       //  MOBILE
       closeSideNav();

		// UPDATE NAV
		var link = jQuery(this);
        linkURL = jQuery(link).attr("href");
        updateNav(linkURL);

		// LOAD PAGE
		ajax_goToActualPage(true);

		// UPDATE HISTORY
		updateHistory(linkURL);

	});
}

function setURL(hash){

    hash = hash.replace('https://' + app.url + '/', '');

    if(window.location.pathname.length > 0) {
        location('https://' + app.url);
    }

    return location.replace(
        '#' + hash.replace(/^#/, '')
    );
}

function refreshMenuHome() {
    // MENU
    if($(window).scrollTop()<150){
        $('#masthead').removeClass("mini");
    } else {
        $('#masthead').addClass("mini");
    }
}

function activateHeaderScroll() {
    if(!scrollHeader){
        scrollHeader = $(window).scroll(function() {
            if($('.home').length != 0 && !inTransition){
                refreshMenuHome();
            }
        });
    }
}

function disableHeaderScroll() {
    //$(window).unbind('scroll');
}

// INIT AJAX
function initAjax(){

    //console.log("AJAX INIT");

    // Header on scroll
    activateHeaderScroll();

	// NAV | Initial state
	updateNav();

	// ACTIVATE PRIMARY NAV
    activatePrimaryNav();
    activateFooterNav();
    activateLangNav();
    activateContent();

    // INIT HISTORY
	updateHistory(app.currentURL);
}

(function(w, d){

    // FADE IN
    $( '#content .mainContent' ).animate({
        opacity: 1
    }, 500,'easeOutQuad');

    // ON POP STATE
    window.onpopstate = function(ev) {
        if(ev.state != null) {
            if(ev.state.ajx === true) {
                updateNav(ev.state.link);
                ajax_goToActualPage();
            }
        }
    }
    // INIT AJAX NAVIGATION (FIRST)
    initAjax();
}(window, document));